import { Component, OnInit,NgZone } from '@angular/core';
import { cardAnimations } from 'src/app/utilities/animations';
import { SharedServiceService } from 'src/app/services/shared-service.service';
import { Router } from '@angular/router';
import { GENERIC_ERROR, GENERIC_ERRORS, RETRIEVE_APPLICATION_URL_DECRYPT, base_https_url, VALIDATE_QDE_OTP_URL_DECRYPT, IS_CAMPAIGN, TRACK_APPLICATION_URL_DECRYPT } from 'src/app/config/app-settings.config';
import { ThemeService } from 'src/app/services/theme.service';
import { EncrDecrService } from 'src/app/services/encr-decr-service.service';
import { LoaderService } from 'src/app/services/loader.service';
import { QdeService } from 'src/app/services/qde.service';
import { xmlToJson, getDeviceSize } from 'src/app/utilities/utilities.file';
declare var _satellite: any;

@Component({
  selector: 'app-retrieve-app',
  templateUrl: './retrieve-app.component.html',
  styleUrls: ['./retrieve-app.component.scss'],
  animations: [cardAnimations]
})
export class RetrieveAppComponent implements OnInit {
  showFirstName: any = true;
  showOtpView: any;
  showMobNum: any = true;
  firstName: any;
  mobileNum: any;
  retrieveBtnDisabled: any =true;
  nextBtnDisabled: any = true;
  isAnimationDisabled: boolean;
  retrieverServiceError: any;
  otpServiceError:any;
  otpCounter = 0;
  resendOtp: boolean = false;
  maxAttemptOtp: boolean = false;
  genericErrors: any = GENERIC_ERRORS;
  partnerCode: any = sessionStorage.getItem('partner-code');
  containerType: any = sessionStorage.getItem('container-type');
  domainUrl: any;
  otp: any;
  displayShortCodeHtml: boolean = false;
  optValidateCount=0;
  isMobile: boolean;

  constructor(
    private sharedData: SharedServiceService,
    private router: Router,
    private themeService: ThemeService,
    private encryptDecService:EncrDecrService,
    private loaderService: LoaderService,
    private qdeService: QdeService,
    private ngZone: NgZone
  ) { 
    this.partnerCode = this.themeService.partnerCode;
  }

  ngOnInit() {
    if (getDeviceSize() === 'small') {
      this.isMobile = true;
    } 
    window.onresize = (e) => {
      this.ngZone.run(() => {
        if (getDeviceSize() === 'small') {
          this.isMobile = true;
        } else {
          
          this.isMobile = false;
        }
      });
    };
    this.domainUrl= base_https_url;
    this.showFirstName=this.sharedData.showFirstName;
    this.showMobNum= this.sharedData.showMobNum;
    this.showOtpView = this.sharedData.showOtpViewRetrieve;

    this.isAnimationDisabled =  true;
    this.mobileNum = this.themeService.retrieveMob;
  }

  nextButtonClick(){
    this.isAnimationDisabled =  false;
    this.sharedData.showFirstName=false;
    this.sharedData.showMobNum=true;

    this.showFirstName=false;
    this.showMobNum = true;
  }
  
  retrieveButtonClick(){
    // this.isAnimationDisabled =  false;
    // this.sharedData.showFirstName=false;
    // this.sharedData.showMobNum=false;
   // this.sharedData.showOtpViewRetrieve=true;

    // this.showFirstName=false;
    // this.showMobNum = false;
     //this.showOtpView = false;

    let retrieveRequest = {
      "WSCallUserFirstName": this.firstName,
      "WSCallUserMobileNumber": this.mobileNum
    }

    this.sharedData.retriveApplication(retrieveRequest).subscribe((result: any) => {
      result = RETRIEVE_APPLICATION_URL_DECRYPT ? this.encryptDecService.get(result): result;     
      console.log(result);
      if(result){
        if (result.RetrieveLeadRsType && result.RetrieveLeadRsType.WSCallLeadRefNumber) {
          this.sharedData.paramsappNumber = result.RetrieveLeadRsType.WSCallLeadRefNumber;
          this.trackApplication();
        }
        else if(result.RetrieveLeadRsType && result.RetrieveLeadRsType.WSCallChannelCode){
          // this.retrieverServiceError = ''
          this.sharedData.retrievedApplicationResponse = result;
          let channelCode = result.RetrieveLeadRsType.WSCallChannelCode ? result.RetrieveLeadRsType.WSCallChannelCode : '';
          if (channelCode) {
            if (channelCode == "EALB") {
              this.sharedData.paramschannel = '901'
            } else if (channelCode == "EABP") {
              this.sharedData.paramschannel = '701'
            }
          }
          if (this.sharedData.retrievedApplicationResponse.RetrieveLeadRsType.WSCallChannelCode) {
            let masterReq = {
              cardType: this.sharedData.retrievedApplicationResponse.RetrieveLeadRsType.WSCallCardType,
              cardChannelCode: this.sharedData.retrievedApplicationResponse.RetrieveLeadRsType.WSCallChannelCode,
              cityList: 'N',
              companyList: 'N',
              bancaCityList: 'N',
              userCity: this.sharedData.retrievedApplicationResponse.RetrieveLeadRsType.WSCallUserCity || null
            }
            this.loaderService.show()
            this.qdeService.fetchMatserData(masterReq).subscribe((response: any) => {
              if (response.eapplyMasterDataRsType.statusCode === "000") {
                this.sharedData.InitialMasterResponse = response;
                if ((this.sharedData.paramschannel && this.sharedData.paramschannel == '701') || (this.sharedData.paramschannel && this.sharedData.paramschannel == '901')) {
                  this.sharedData.promoCode = response 
                        && response.eapplyMasterDataRsType 
                        && response.eapplyMasterDataRsType.wcpParameters 
                        && response.eapplyMasterDataRsType.wcpParameters.promoCode 
                          ? response.eapplyMasterDataRsType.wcpParameters.promoCode: '' ;
                }
                this.loaderService.hide()
              } else {
                this.loaderService.hide()
                this.retrieverServiceError = GENERIC_ERROR;
                window["digitalData"].error = { message: GENERIC_ERROR };
                _satellite.track('form_error');
              }
            }, err => {
              console.log('Service Error', err);
              this.retrieverServiceError = GENERIC_ERROR;
              this.loaderService.hide();
            });
          }
          console.log("retrieve application service response is " + result);
          let sequenceId = result.RetrieveLeadRsType.WSCallSequenceId ? result.RetrieveLeadRsType.WSCallSequenceId : '';
          this.sharedData.amoSequeceNumber = sequenceId;
          if (IS_CAMPAIGN) {
            window["digitalData"].page = { pageName: 'sbi-card:eapply:campaign', pageType: 'Campaign' };
          } else {
            window["digitalData"].page = { pageName: 'sbi-card:eapply:retrieve', pageType: 'Eapply' };
          }
          let mobNumber = this.mobileNum;
          this.sendOtpForValidation(mobNumber, false);
          console.log("otp send for retrieve");
        } else if (result.RetrieveLeadErrorRsType && result.RetrieveLeadErrorRsType.status.toLowerCase() == 'failure') {
          window["digitalData"].error = { message: GENERIC_ERROR };
          _satellite.track('form_error');
          this.retrieverServiceError = result.RetrieveLeadErrorRsType.errorMessage;
          //  this.router.navigate(['track-partner-error'], { queryParamsHandling: "preserve", skipLocationChange: this.partnerCode && this.containerType?true:false });
        } else{
          window["digitalData"].error = { message: GENERIC_ERROR };
          _satellite.track('form_error');
          //  this.router.navigate(['track-partner-error'], { queryParamsHandling: "preserve", skipLocationChange: this.partnerCode && this.containerType?true:false });
          this.retrieverServiceError = GENERIC_ERROR;
        }
      } else{
        window["digitalData"].error = { message: GENERIC_ERROR };
        _satellite.track('form_error');
        //  this.router.navigate(['track-partner-error'], { queryParamsHandling: "preserve", skipLocationChange: this.partnerCode && this.containerType?true:false });
        this.retrieverServiceError = GENERIC_ERROR;
      }
    },
      error => {
        console.log("Error has occured:", error);
        window["digitalData"].error = { message: GENERIC_ERROR };
        _satellite.track('form_error');
        //  this.router.navigate(['track-partner-error'], { queryParamsHandling: "preserve", skipLocationChange: this.partnerCode && this.containerType?true:false });
        this.retrieverServiceError = GENERIC_ERROR;
      });


  }
  onFirstNameChange(){
    this.retrieverServiceError = false;
    if(this.mobileNum && this.firstName) {
      if(this.mobileNum.length == 10 && (this.firstName.length >1 && this.firstName.length <=12)){
        this.retrieveBtnDisabled=false;
      }
    }    
    else{
      this.retrieveBtnDisabled=true;
    } 
    
  }
  onMobNumChange(){
    this.retrieverServiceError = false;
    if(this.mobileNum.length == 10 && (this.firstName.length >1 && this.firstName.length <=12)){
      this.retrieveBtnDisabled=false;
    }
    else{
      this.retrieveBtnDisabled=true;
    }
  }
  resendClick(){
    this.sendOtpForValidation(this.mobileNum, false);
  }
  cancelClick(){
    this.isAnimationDisabled =  false;
    this.sharedData.showFirstName=false;
    this.sharedData.showMobNum=true;
    this.sharedData.showOtpViewRetrieve=false;

    this.showFirstName=false;
    this.showMobNum = true;
    this.showOtpView = false;
    this.retrieveBtnDisabled=false;
  }

  numberOnly(event) {
    if(event.keyCode !=8) {
        let regex2 = /[0-9]/;
      if (event.key.match(regex2)) {
        return true;
      } else {
        return false;
      }
    }
    
  }
  alphabetsOnly(event) {
    let regex = /[a-zA-Z]/;
    if (event.key.match(regex)) {
      return true;
    } else {
      return false;
    }
  }

  sendOtpForValidation(mobileNum, flag) {
    console.log(this.otpCounter)
    if (this.otpCounter >= 5) {
      return;
    }
    if (flag) {
      this.resendOtp = true;
      setTimeout(() => {
        this.resendOtp = false;
      }, 3000)
    }
    let reasonCode: any;
    if (this.sharedData.paramsappNumber) {
      // reasonCode = '132';
      reasonCode = '160';
    } else {
      // reasonCode = '121';
      reasonCode = '161';
    }

    console.log('reasoncode: ', reasonCode);

    this.sharedData.sendOtp(mobileNum, '', flag, reasonCode).subscribe((res: any) => {

      console.log(res)
      if (res && res.OTPGenerationRsType && res.OTPGenerationRsType.status && res.OTPGenerationRsType.status.toLowerCase() == "success" && res.OTPGenerationRsType.statusCode === "000") {
        // this.sendOtpServiceError = ''
        // this.displayShortCodeHtml = false;
        // this.isAnimationDisabled =  false;
        this.themeService.retrieveMob = this.mobileNum;
        this.sharedData.showFirstName=false;
        this.sharedData.showMobNum=false;
        this.sharedData.showOtpViewRetrieve=true;

        this.showFirstName=false;
        this.showMobNum = false;
        this.showOtpView = true;
        this.retrieveBtnDisabled=true;
        console.log("otp send for retrive or track application")
        this.displayShortCodeHtml = false;
        this.otpCounter = this.otpCounter + 1;
        this.otp='';
        (this.otpCounter == 5) ? this.maxAttemptOtp = true : this.maxAttemptOtp = false;
      } else {
        // this.sendOtpServiceError = this.generic_error.sendOtpError
        window["digitalData"].error = { message: GENERIC_ERROR };
        _satellite.track('form_error');
        this.otpServiceError = this.genericErrors.sendOtpError;
      }
    },
      error => {
        window["digitalData"].error = { message: GENERIC_ERROR };
        _satellite.track('form_error');
        console.log("Error has occured:", error);
        this.otpServiceError = this.genericErrors.sendOtpError
      }
    )

  }

  trackApplication() {
    let request = {
      "applicationNumber": this.sharedData.paramsappNumber,
      "leadRefNo": this.sharedData.paramsappNumber
    }
    console.log(request)
    this.sharedData.trackApplication(request).subscribe((response: any) => {
      let result: any;
      if (response) {
        result = TRACK_APPLICATION_URL_DECRYPT ? { ...this.encryptDecService.get(response.body) } : { ...response.body };
      }
      if(result){
        
        if(result.eapplyApplicantDetails && result.eapplyApplicantDetails.mobileNumber){

          let accessToken: any;
          let expiryTime: any;
          if (response.headers && response.headers.get("access_token")) {
            accessToken = response.headers.get("access_token");
          }
          if (response.headers && response.headers.get("expiry_time")) {
            expiryTime = response.headers.get("expiry_time");
          }
          if (accessToken) {
            sessionStorage.setItem("s24_access_token", accessToken);
          }
          if (expiryTime) {
            sessionStorage.setItem("s24_expiry_time", expiryTime);
          }
        //  this.sharedData.paramsappNumber = this.applicationNum;

        this.mobileNum = result.eapplyApplicantDetails.mobileNumber;
        this.themeService.trackMob = this.mobileNum;
        this.sharedData.trackApplicationResponse = result;
        this.sharedData.applicantApplicationNumber = result.applicationNumber;
        this.sharedData.applicantName = result.eapplyApplicantDetails.firstName;

        this.sharedData.navigateToCompleteApp = result.enableDataCaptureFlag;
        this.sharedData.navigateToDocUpload =  result.enableDocumentListFlag;
        this.sharedData.navigateToScheduleAppointment = result.enableAppointmentFlag;
        this.sharedData.navigateToAddon = result.enableAddOnListFlag;
        this.sharedData.navigateToCrossSell = result.enableCrossSellFlag;
        this.sharedData.navigateToResheduleAppointment = result.enableReSchdAppointmentFlag;
        this.sharedData.sbic_card_Type = result.cardType;
        let channelCode = result.channelCode ? result.channelCode : '';
        if (channelCode) {
          if (channelCode == "EALB") {
            this.sharedData.paramschannel = '901';
            sessionStorage.setItem('channelId','901');
          } else if (channelCode == "EABP") {
            this.sharedData.paramschannel = '701';
            sessionStorage.setItem('channelId','701');
          }
        }

        if (IS_CAMPAIGN) {
          window["digitalData"].page = { pageName: 'sbi-card:eapply:campaign', pageType: 'Campaign' };
        } else {
          window["digitalData"].page = { pageName: 'sbi-card:eapply:track', pageType: 'Eapply' };
        }

        window["digitalData"].decisionType = this.sharedData.trackApplicationResponse.statusCode;
        window["digitalData"].instantDecision = this.sharedData.trackApplicationResponse.statusDescription;
        window["digitalData"].eapply = { number: this.sharedData.applicantApplicationNumber };
        window["digitalData"].application = { status: "complete" };
        if (this.sharedData.cardName) {
          window["digitalData"].card = { cardName: this.sharedData.cardName };
        }
        _satellite.track("track_application");
         this.sendOtpForValidation(this.mobileNum, false);
 
         this.sharedData.showFirstName=false;
          this.sharedData.showMobNum=false;
          this.sharedData.showOtpViewRetrieve=true;

          this.showFirstName=false;
          this.showMobNum = false;
          this.showOtpView = true;
 
        }else if(result.status && result.status.toLowerCase() == 'failure' && result.errorMessage){
          this.retrieverServiceError = result.errorMessage;
          window["digitalData"].error = { message: GENERIC_ERROR };
          _satellite.track('form_error');
          // this.router.navigate(['track-partner-error'], { queryParamsHandling: "preserve", skipLocationChange: this.partnerCode && this.containerType?true:false });
        }else {
          window["digitalData"].error = { message: GENERIC_ERROR };
         _satellite.track('form_error');
          this.retrieverServiceError = this.genericErrors.genError;
          // this.router.navigate(['track-partner-error'], { queryParamsHandling: "preserve", skipLocationChange: this.partnerCode && this.containerType?true:false });
         }
        
      }
      else{
        window["digitalData"].error = { message: GENERIC_ERROR };
        _satellite.track('form_error');
        this.retrieverServiceError = this.genericErrors.genError; 
        //  this.router.navigate(['track-partner-error'], { queryParamsHandling: "preserve", skipLocationChange: this.partnerCode && this.containerType?true:false });
      }
    },
    
    error => {
     console.log("Error has occured:", error);
     this.retrieverServiceError = this.genericErrors.genError;   
      // this.router.navigate(['track-partner-error'], { queryParamsHandling: "preserve", skipLocationChange: this.partnerCode && this.containerType?true:false });      
   });
    // this.sharedData.trackApplication(request).subscribe((res: any) => {
    //   if (res && res.status && res.status.toLowerCase() == 'failure' && res.errorMessage) {
    //     console.log(res)
    //     this.retrieverServiceError = res.errorMessage
    //     this.router.navigate(['/track-application', 'track-error']);
    //   } else if (res && res.eapplyApplicantDetails && res.eapplyApplicantDetails.mobileNumber) {
    //     this.retrieverServiceError = ''
    //     console.log(res)
    //     this.mobileNumber = res.eapplyApplicantDetails.mobileNumber;
    //     console.log(this.mobileNumber)
    //     this.sharedData.trackApplicationResponse = res;
    //     this.sharedData.applicantApplicationNumber = res.applicationNumber;
    //     this.sharedData.applicantName = res.eapplyApplicantDetails.firstName;
    //     this.sharedData.navigateToCompleteApp = res.enableDataCaptureFlag;
    //     this.sharedData.navigateToDocUpload = res.enableDocumentListFlag;
    //     this.sharedData.navigateToScheduleAppointment = res.enableAppointmentFlag;
    //     this.sharedData.navigateToAddon = res.enableAddOnListFlag;
    //     this.sharedData.navigateToCrossSell = res.enableCrossSellFlag;
    //     this.sharedData.navigateToResheduleAppointment = res.enableReSchdAppointmentFlag;
    //     let chaneelCode = res.channelCode ? res.channelCode : '';
    //     if (chaneelCode) {
    //       if (chaneelCode == "EALB") {
    //         this.sharedData.paramschannel = '901'
    //       } else if (chaneelCode == "EABP") {
    //         this.sharedData.paramschannel = '701'
    //       }
    //     }
    //     console.log('track application response for complete application navigation' + this.sharedData.trackApplicationResponse)
    //     console.log("otp send for track")
    //     this.sendOtpForValidation(this.mobileNumber, false);
    //   }
    // },
    //   error => {
    //     console.log("Error has occured:", error);
    //     this.router.navigate(['/track-application', 'track-error']);
    //     this.retrieverServiceError = GENERIC_ERROR;
    //   })
  }

  validateOtp(otp, mobileNumber) {
    this.otpServiceError = false;
    // console.log(otp)
    if (otp.length < 6) {
      //  console.log(otp.length)
      return
    } else if (otp.length == 6) {
      const requestBody = {
        cardNumber: '000' + mobileNumber + '999999',
        otp: otp || null,
        reasonCode: '160',
        mobileNumber: ''+ mobileNumber,
        dsignString: this.sharedData.uuidString
      }
      let reasonCode: any;
      if (this.sharedData.paramsappNumber) {
        reasonCode = '160';
      } else {
        reasonCode = '161';
      }
      this.sharedData.validateOtp(requestBody, reasonCode).subscribe((res: any) => {
        if(res){
          res = VALIDATE_QDE_OTP_URL_DECRYPT ? this.encryptDecService.get(res) : res;
          console.log("response of otp validation" + res)
        }

        if (res && res.OtpValidationRsType && res.OtpValidationRsType.status && res.OtpValidationRsType.status.toLowerCase() == "success" && res.OtpValidationRsType.statusCode === "000") {
          // this.otpValidationServiceError = '';
          this.sharedData.applicantName = this.firstName;
          this.sharedData.paramsmobileNo =  this.mobileNum;
          this.sharedData.paramsfirstName = this.firstName;
          _satellite.track("mobile_number_verify");
          this.optValidateCount += 1;
          if (res.OtpValidationRsType.signedValue) {
            this.qdeService.signedValueResponse = res.OtpValidationRsType.signedValue;
          }
          if (this.sharedData.paramsappNumber && res.OtpValidationRsType.mobileNumber == this.mobileNum) {
            this.router.navigate(['/apply', 'track-app'], { queryParamsHandling: "preserve", skipLocationChange: this.partnerCode && this.containerType?true:false });
          }
          else if (((this.sharedData.paramsmobileNo && this.sharedData.paramsfirstName) || this.sharedData.paramsshortCode) && res.OtpValidationRsType.mobileNumber == this.mobileNum) {
            this.router.navigate(['/', 'apply'], { queryParamsHandling: "preserve", skipLocationChange: this.partnerCode && this.containerType?true:false });
          }
          else {
            //  this.router.navigate(['track-partner-error'], { queryParamsHandling: "preserve", skipLocationChange: this.partnerCode && this.containerType?true:false });
            this.otpServiceError = 'please enter valid OTP';
          }
        } else {
          console.log("otp is incorrect")
          this.otp = '';
          // this.router.navigate(['track-partner-error'], { queryParamsHandling: "preserve", skipLocationChange: this.partnerCode && this.containerType?true:false });
          this.otpServiceError = 'please enter valid OTP';
          window["digitalData"].error = { message: GENERIC_ERROR };
        }
      }),
        error => {
          console.log("Error has occured:", error);
          // this.router.navigate(['track-partner-error'], { queryParamsHandling: "preserve", skipLocationChange: this.partnerCode && this.containerType?true:false });
          this.otpServiceError = this.genericErrors.sendOtpError;
          window["digitalData"].error = { message: GENERIC_ERROR };
        }
    }
  }

}
